/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RevisdomAPIViewModelsEntryDuplicateEntryResponse } from './RevisdomAPIViewModelsEntryDuplicateEntryResponse';
import {
    RevisdomAPIViewModelsEntryDuplicateEntryResponseFromJSON,
    RevisdomAPIViewModelsEntryDuplicateEntryResponseFromJSONTyped,
    RevisdomAPIViewModelsEntryDuplicateEntryResponseToJSON,
    RevisdomAPIViewModelsEntryDuplicateEntryResponseToJSONTyped,
} from './RevisdomAPIViewModelsEntryDuplicateEntryResponse';

/**
 * API yanıtları için genel response modeli
 * @export
 * @interface ApiResponse1DuplicateEntryResponse
 */
export interface ApiResponse1DuplicateEntryResponse {
    /**
     * İşlemin başarılı olup olmadığını belirtir
     * @type {boolean}
     * @memberof ApiResponse1DuplicateEntryResponse
     */
    success?: boolean;
    /**
     * İşlem sonucu hakkında bilgi mesajı
     * @type {string}
     * @memberof ApiResponse1DuplicateEntryResponse
     */
    message?: string | null;
    /**
     * 
     * @type {RevisdomAPIViewModelsEntryDuplicateEntryResponse}
     * @memberof ApiResponse1DuplicateEntryResponse
     */
    data?: RevisdomAPIViewModelsEntryDuplicateEntryResponse;
    /**
     * Hata durumunda hata detayları
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ApiResponse1DuplicateEntryResponse
     */
    errors?: { [key: string]: Array<string>; } | null;
}

/**
 * Check if a given object implements the ApiResponse1DuplicateEntryResponse interface.
 */
export function instanceOfApiResponse1DuplicateEntryResponse(value: object): value is ApiResponse1DuplicateEntryResponse {
    return true;
}

export function ApiResponse1DuplicateEntryResponseFromJSON(json: any): ApiResponse1DuplicateEntryResponse {
    return ApiResponse1DuplicateEntryResponseFromJSONTyped(json, false);
}

export function ApiResponse1DuplicateEntryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResponse1DuplicateEntryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : RevisdomAPIViewModelsEntryDuplicateEntryResponseFromJSON(json['data']),
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function ApiResponse1DuplicateEntryResponseToJSON(json: any): ApiResponse1DuplicateEntryResponse {
    return ApiResponse1DuplicateEntryResponseToJSONTyped(json, false);
}

export function ApiResponse1DuplicateEntryResponseToJSONTyped(value?: ApiResponse1DuplicateEntryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'data': RevisdomAPIViewModelsEntryDuplicateEntryResponseToJSON(value['data']),
        'errors': value['errors'],
    };
}

